import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Bookmark, Loader2, Check } from "lucide-react";
import { api } from "@/lib/api";
import { previewCss, previewBgCss } from "@/lib/presets";

// "Saved designs" picker: user's own presets, newest first. Picking one applies it to the timeline captions.
export default function SavedDesignsDialog({ open, onOpenChange, onPick }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!open) return;
    setItems(null);
    api.listPresets().then((ps) => setItems((ps || []).filter((p) => !p.is_builtin))).catch(() => setItems([]));
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl border-white/10 bg-[#121212]" data-testid="saved-designs-dialog">
        <DialogTitle className="flex items-center gap-2 font-display text-lg font-black"><Bookmark size={18} className="text-[#8B5CF6]" /> Saved designs</DialogTitle>
        <p className="-mt-2 text-xs text-[#A1A1AA]">Pick a design to apply it to every caption on the timeline. With several caption layers, multi-look designs give layer 1 the first look, layer 2 the second, and so on.</p>
        {items === null ? <div className="flex justify-center py-10"><Loader2 className="animate-spin text-[#00F0FF]" /></div>
          : !items.length ? <p className="py-10 text-center text-sm text-[#666]" data-testid="saved-designs-empty">No saved designs yet — use “Save this preset” at the bottom of the animation window.</p>
          : (
            <div className="grid max-h-[60vh] grid-cols-2 gap-2.5 overflow-y-auto pr-1 sm:grid-cols-3">
              {items.map((p) => {
                const bg = previewBgCss(p.definition);
                return (
                  <button key={p.id} onClick={() => onPick(p)} data-testid={`saved-design-${p.id}`}
                    className="group flex flex-col overflow-hidden rounded-xl border border-white/10 bg-white/[0.02] text-left transition-colors hover:border-[#00F0FF]/60">
                    <div className="relative flex h-20 items-center justify-center bg-[#0a0a0a] px-2">
                      {bg && <div className="absolute inset-x-6 inset-y-6 rounded-md" style={bg} />}
                      <span className="relative truncate text-lg" style={previewCss(p.definition)}>{p.definition?.sample || "Your Text"}</span>
                    </div>
                    <div className="flex items-center justify-between gap-1 px-2.5 py-2">
                      <div className="min-w-0"><div className="truncate text-xs font-semibold text-white">{p.name}</div>
                        <div className="text-[10px] text-[#666]">{p.created_at ? new Date(p.created_at).toLocaleDateString() : ""}{p.definition?.wordPattern ? ` · ${p.definition.wordPattern.length} looks` : ""}</div></div>
                      <span className="flex shrink-0 items-center gap-1 rounded-full bg-[#00F0FF]/10 px-2 py-0.5 text-[10px] font-bold text-[#00F0FF] opacity-0 transition-opacity group-hover:opacity-100"><Check size={10} /> Apply</span>
                    </div>
                  </button>
                );
              })}
            </div>
          )}
      </DialogContent>
    </Dialog>
  );
}
